export const TRANSITION_TEXTS = {
  title: 'Valoración de entrada / transición',
  info:
    'Solo para ingresos por ajuste o documentos anteriores al costeo. Requiere permiso de valoración; conserva intacto el documento original.',
  price: 'Precio unitario aprobado en pesos',
  notes: 'Fuente y motivo de la estimación',
  evidence: 'Referencia de respaldo / aprobación',
  noArticle: 'Material sin descripción',
  itemTitle: (articleName, quantity) =>
    `Valoración de entrada · ${articleName}${quantity != null ? ` · ${quantity}` : ''}`,
};
